import type { NotificationEntry } from '../types'

/**
 * Health notifications are listed first and never mixed into the social group.
 * Community noise must never outrank a health reminder.
 */
export const healthNotifications: NotificationEntry[] = [
  {
    id: 'n-check',
    kind: 'check',
    text: {
      'pt-BR': 'Faltam 50 Bee para fechar o seu Daily Check de hoje.',
      'en-US': '50 Bee left to close today’s Daily Check.',
    },
    hoursAgo: 1,
    unread: true,
  },
  {
    id: 'n-streak',
    kind: 'streak',
    text: {
      'pt-BR': 'Sua sequência de 12 dias termina à meia-noite se o dia não fechar.',
      'en-US': 'Your 12-day streak ends at midnight if the day is not closed.',
    },
    /** Shown instead of `text` while a Streak Protection is available. */
    protectedText: {
      'pt-BR': 'Hoje ainda não fechou. Sua Proteção de Sequência disponível pode manter seus 12 dias se precisar.',
      'en-US': 'Today isn’t closed yet. Your available Streak Protection can keep your 12 days if needed.',
    },
    hoursAgo: 3,
    unread: true,
  },
  {
    id: 'n-review',
    kind: 'review',
    text: {
      'pt-BR': 'Sua Revisão Semanal fica disponível domingo, a partir das 18h.',
      'en-US': 'Your Weekly Review unlocks Sunday, from 6pm.',
    },
    hoursAgo: 22,
    unread: false,
  },
]

export const socialNotifications: NotificationEntry[] = [
  {
    id: 'n-badge',
    kind: 'badge',
    text: {
      'pt-BR': 'Você conquistou a medalha Semana de Ferro.',
      'en-US': 'You earned the Iron Week badge.',
    },
    hoursAgo: 2,
    unread: true,
  },
  {
    id: 'n-like',
    kind: 'like',
    actorId: 'lucas',
    text: {
      'pt-BR': 'curtiu o seu post de corrida.',
      'en-US': 'liked your running post.',
    },
    hoursAgo: 4,
    unread: true,
  },
  {
    id: 'n-comment',
    kind: 'comment',
    actorId: 'marina',
    text: {
      'pt-BR': 'comentou: “Esse horário muda tudo.”',
      'en-US': 'commented: “That time of day changes everything.”',
    },
    hoursAgo: 5,
    unread: false,
  },
  {
    id: 'n-follow',
    kind: 'follow',
    actorId: 'juliana',
    text: {
      'pt-BR': 'começou a seguir você.',
      'en-US': 'started following you.',
    },
    hoursAgo: 9,
    unread: false,
  },
  {
    id: 'n-achievement',
    kind: 'achievement',
    actorId: 'rafael',
    text: {
      'pt-BR': 'alcançou 31 dias de sequência.',
      'en-US': 'reached a 31-day streak.',
    },
    hoursAgo: 14,
    unread: false,
  },
]
